import { Frequency } from "./enums";

const FREQUENCY_TO_MINUTES: Record<Frequency, number> = {
  [Frequency.TenMinutes]: 10,
  [Frequency.QuarterHour]: 15,
  [Frequency.Hour]: 60,
  [Frequency.Day]: 1440,
  [Frequency.Month]: 43200,
  [Frequency.Year]: 525600
};

export function getMinsFromFrequency(frequency: Frequency): number {
  return FREQUENCY_TO_MINUTES[frequency];
}

export function getMilliSecsFromFrequency(frequency: Frequency): number {
  return getMinsFromFrequency(frequency) * 60 * 1000;
}
